import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  paginationBlock: {
    display: 'flex',
    textAlign: 'center',
    margin: ' 30px 0 5px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerCount: {
    marginBottom: '0',
    paddingTop: '75px',
    '@media(min-width: 800px)': {
      marginBottom: '35px',
      paddingTop: '0',
    },
  },
  pagination: {
    display: 'inline-flex',
    justifyContent: 'center',
    textAlign: 'center',
  },
  pageCount: {
    position: 'absolute',
    left: '16px',
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    '& span': {
      color: '#616995',
      fontSize: '12px',
    },
  },
  pageCountAmount: {
    position: 'absolute',
    right: '16px',
    color: '#616995',
    fontSize: '12px',
    lineHeight: '40px',
    background: '#f7f8f8',
    padding: '0 10px',
    height: '26px',
    lineHeight: '29px',
    borderRadius: '5px',
    margin: '8px 0 0',
  },
  dotts: {
    fontSize: '13px',
    padding: ' 0 20px',
    lineHeight: '36px',
    color: '#2b3990',
    fontWeight: '900',
  },
  itemsPerPage: {
    border: '1px solid #ebebeb',
    height: '40px',
    padding: ' 0 12px',
    borderRadius: '5px',
    background: '#fff',
    color: '#4a4a4a',
    fontSize: '13px',
    cursor: 'pointer',
    outline: 'none',
    '&[disabled]': {
      color: '#49555d57',
      cursor: 'auto',
      background: '#fafafa',
    },
    '& option': {
      fontSize: '13px',
      textAlign: 'center',
    },
    '&:focus-visibile': {
      outline: 'none',
    },
  },
  pageItem: {
    padding: '8px 0',
    border: 'none',
    background: '#fff',
    border: '1px solid #dfdfdf',
    width: '45px',
    color: '#303d8f',
    cursor: 'pointer',
    '@media(min-width: 800px)': {
      width: '59px',
    },
    '&:first-child': { borderRadius: ' 8px  0 0 8px', borderRight: '0' },
    '&:last-child': { borderRadius: '0 8px 8px 0', borderLeft: '0' },
    '&:hover': {
      background: 'rgba(48, 61, 143, 0.05)',
      fontWeight: '900',
      color: '#2a2a2a',
    },

    '&[disabled]': {
      color: '#49555d57',
      cursor: 'auto',
      background: '#fafafa',
      fontWeight: '300',
      '&:hover': {
        fontWeight: '300',
      },
    },

    '&.active': {
      background: 'rgba(48, 61, 143, 0.05)',
      fontWeight: '900',
      color: '#2a2a2a',
      cursor: 'auto',
      border: '1px solid #dfdfdf',

      '&:hover': {
        background: 'rgba(48, 61, 143, 0.05)!important',
        color: '#2a2a2a!important',
        fontWeight: '900!important',
      },
    },
  },
}));
